import { render } from "preact";
import { App } from "./App.jsx";
import { initTheme } from "./hooks/useTheme.js";
import { startKeyboardViewport } from "./utils/keyboardViewport.js";
import "./styles.css";

initTheme();
startKeyboardViewport();
render(<App />, document.getElementById("app"));
